/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY Backend
 * PEXIFY operating system backend — privately governed commerce ecosystem. M3 başlangıcı: FastAPI shell. Faz 1-6 schema RATIFIED; per-component CRUD + RBAC + audit emit + engines (M-AUDIT / M-WALLET / M-POLICY / M-NOTIF) coming.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListAdminMessagingConversationsParams,
  ListAdminMessagingMessagesParams,
  ListMessagingConversationsParams,
  ListMessagingMessagesParams,
  MessagingAdminAssignmentRequest,
  MessagingAdminConversation,
  MessagingAdminConversationPage,
  MessagingAdminOperationsRequest,
  MessagingCapabilities,
  MessagingConversationCreate,
  MessagingConversationPage,
  MessagingConversationRead,
  MessagingConversationUpdate,
  MessagingMessageCreate,
  MessagingMessagePage,
  MessagingMessageRead,
  MessagingReadReceipt,
  MessagingReadRequest,
  MessagingUnreadSummary
} from '../model';

import { orvalClient } from '../../orval-client';




export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


export type listAdminMessagingConversationsResponse200 = {
  data: MessagingAdminConversationPage
  status: 200
}

export type listAdminMessagingConversationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listAdminMessagingConversationsResponseSuccess = (listAdminMessagingConversationsResponse200) & {
  headers: Headers;
};
export type listAdminMessagingConversationsResponseError = (listAdminMessagingConversationsResponse422) & {
  headers: Headers;
};

export type listAdminMessagingConversationsResponse = (listAdminMessagingConversationsResponseSuccess | listAdminMessagingConversationsResponseError)

export const getListAdminMessagingConversationsUrl = (params?: ListAdminMessagingConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/messaging/conversations?${stringifiedParams}` : `/api/v1/admin/messaging/conversations`
}

/**
 * @summary List Admin Messaging Conversations
 */
export const listAdminMessagingConversations = async (params?: ListAdminMessagingConversationsParams, options?: RequestInit): Promise<listAdminMessagingConversationsResponse> => {

  return orvalClient<listAdminMessagingConversationsResponse>(getListAdminMessagingConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminMessagingConversationsQueryKey = (params?: ListAdminMessagingConversationsParams,) => {
    return [
    `/api/v1/admin/messaging/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminMessagingConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = HTTPValidationError>(params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminMessagingConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminMessagingConversations>>> = ({ signal }) => listAdminMessagingConversations(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminMessagingConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminMessagingConversations>>>
export type ListAdminMessagingConversationsQueryError = HTTPValidationError


export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = HTTPValidationError>(
 params: undefined |  ListAdminMessagingConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = HTTPValidationError>(
 params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = HTTPValidationError>(
 params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Admin Messaging Conversations
 */

export function useListAdminMessagingConversations<TData = Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError = HTTPValidationError>(
 params?: ListAdminMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminMessagingConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getAdminMessagingConversationResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type getAdminMessagingConversationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getAdminMessagingConversationResponseSuccess = (getAdminMessagingConversationResponse200) & {
  headers: Headers;
};
export type getAdminMessagingConversationResponseError = (getAdminMessagingConversationResponse422) & {
  headers: Headers;
};

export type getAdminMessagingConversationResponse = (getAdminMessagingConversationResponseSuccess | getAdminMessagingConversationResponseError)

export const getGetAdminMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}`
}

/**
 * @summary Get Admin Messaging Conversation
 */
export const getAdminMessagingConversation = async (conversationId: string, options?: RequestInit): Promise<getAdminMessagingConversationResponse> => {

  return orvalClient<getAdminMessagingConversationResponse>(getGetAdminMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMessagingConversationQueryKey = (conversationId: string,) => {
    return [
    `/api/v1/admin/messaging/conversations/${conversationId}`
    ] as const;
    }


export const getGetAdminMessagingConversationQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMessagingConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMessagingConversation>>> = ({ signal }) => getAdminMessagingConversation(conversationId, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMessagingConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMessagingConversation>>>
export type GetAdminMessagingConversationQueryError = HTTPValidationError


export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Messaging Conversation
 */

export function useGetAdminMessagingConversation<TData = Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMessagingConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type updateAdminMessagingAssignmentResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type updateAdminMessagingAssignmentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateAdminMessagingAssignmentResponseSuccess = (updateAdminMessagingAssignmentResponse200) & {
  headers: Headers;
};
export type updateAdminMessagingAssignmentResponseError = (updateAdminMessagingAssignmentResponse422) & {
  headers: Headers;
};

export type updateAdminMessagingAssignmentResponse = (updateAdminMessagingAssignmentResponseSuccess | updateAdminMessagingAssignmentResponseError)

export const getUpdateAdminMessagingAssignmentUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/assignment`
}

/**
 * @summary Update Admin Messaging Assignment
 */
export const updateAdminMessagingAssignment = async (conversationId: string,
    messagingAdminAssignmentRequest: MessagingAdminAssignmentRequest, options?: RequestInit): Promise<updateAdminMessagingAssignmentResponse> => {

  return orvalClient<updateAdminMessagingAssignmentResponse>(getUpdateAdminMessagingAssignmentUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingAdminAssignmentRequest)
  }
);}




export const getUpdateAdminMessagingAssignmentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, TError,{conversationId: string;data: MessagingAdminAssignmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, TError,{conversationId: string;data: MessagingAdminAssignmentRequest}, TContext> => {

const mutationKey = ['updateAdminMessagingAssignment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, {conversationId: string;data: MessagingAdminAssignmentRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateAdminMessagingAssignment(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminMessagingAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>>
    export type UpdateAdminMessagingAssignmentMutationBody = MessagingAdminAssignmentRequest
    export type UpdateAdminMessagingAssignmentMutationError = HTTPValidationError

    /**
 * @summary Update Admin Messaging Assignment
 */
export const useUpdateAdminMessagingAssignment = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingAssignment>>, TError,{conversationId: string;data: MessagingAdminAssignmentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminMessagingAssignment>>,
        TError,
        {conversationId: string;data: MessagingAdminAssignmentRequest},
        TContext
      > => {
      return useMutation(getUpdateAdminMessagingAssignmentMutationOptions(options), queryClient);
    }
    export type claimAdminMessagingConversationResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type claimAdminMessagingConversationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type claimAdminMessagingConversationResponseSuccess = (claimAdminMessagingConversationResponse200) & {
  headers: Headers;
};
export type claimAdminMessagingConversationResponseError = (claimAdminMessagingConversationResponse422) & {
  headers: Headers;
};

export type claimAdminMessagingConversationResponse = (claimAdminMessagingConversationResponseSuccess | claimAdminMessagingConversationResponseError)

export const getClaimAdminMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/claim`
}

/**
 * @summary Claim Admin Messaging Conversation
 */
export const claimAdminMessagingConversation = async (conversationId: string, options?: RequestInit): Promise<claimAdminMessagingConversationResponse> => {

  return orvalClient<claimAdminMessagingConversationResponse>(getClaimAdminMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getClaimAdminMessagingConversationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, TError,{conversationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, TError,{conversationId: string}, TContext> => {

const mutationKey = ['claimAdminMessagingConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, {conversationId: string}> = (props) => {
          const {conversationId} = props ?? {};

          return  claimAdminMessagingConversation(conversationId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClaimAdminMessagingConversationMutationResult = NonNullable<Awaited<ReturnType<typeof claimAdminMessagingConversation>>>

    export type ClaimAdminMessagingConversationMutationError = HTTPValidationError

    /**
 * @summary Claim Admin Messaging Conversation
 */
export const useClaimAdminMessagingConversation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimAdminMessagingConversation>>, TError,{conversationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof claimAdminMessagingConversation>>,
        TError,
        {conversationId: string},
        TContext
      > => {
      return useMutation(getClaimAdminMessagingConversationMutationOptions(options), queryClient);
    }
    export type listAdminMessagingMessagesResponse200 = {
  data: MessagingMessagePage
  status: 200
}

export type listAdminMessagingMessagesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listAdminMessagingMessagesResponseSuccess = (listAdminMessagingMessagesResponse200) & {
  headers: Headers;
};
export type listAdminMessagingMessagesResponseError = (listAdminMessagingMessagesResponse422) & {
  headers: Headers;
};

export type listAdminMessagingMessagesResponse = (listAdminMessagingMessagesResponseSuccess | listAdminMessagingMessagesResponseError)

export const getListAdminMessagingMessagesUrl = (conversationId: string,
    params?: ListAdminMessagingMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/messaging/conversations/${conversationId}/messages?${stringifiedParams}` : `/api/v1/admin/messaging/conversations/${conversationId}/messages`
}

/**
 * @summary List Admin Messaging Messages
 */
export const listAdminMessagingMessages = async (conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: RequestInit): Promise<listAdminMessagingMessagesResponse> => {

  return orvalClient<listAdminMessagingMessagesResponse>(getListAdminMessagingMessagesUrl(conversationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminMessagingMessagesQueryKey = (conversationId: string,
    params?: ListAdminMessagingMessagesParams,) => {
    return [
    `/api/v1/admin/messaging/conversations/${conversationId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminMessagingMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = HTTPValidationError>(conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminMessagingMessagesQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminMessagingMessages>>> = ({ signal }) => listAdminMessagingMessages(conversationId,params, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminMessagingMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminMessagingMessages>>>
export type ListAdminMessagingMessagesQueryError = HTTPValidationError


export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params: undefined |  ListAdminMessagingMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listAdminMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Admin Messaging Messages
 */

export function useListAdminMessagingMessages<TData = Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: ListAdminMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminMessagingMessagesQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createAdminMessagingMessageResponse201 = {
  data: MessagingMessageRead
  status: 201
}

export type createAdminMessagingMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createAdminMessagingMessageResponseSuccess = (createAdminMessagingMessageResponse201) & {
  headers: Headers;
};
export type createAdminMessagingMessageResponseError = (createAdminMessagingMessageResponse422) & {
  headers: Headers;
};

export type createAdminMessagingMessageResponse = (createAdminMessagingMessageResponseSuccess | createAdminMessagingMessageResponseError)

export const getCreateAdminMessagingMessageUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/messages`
}

/**
 * @summary Create Admin Messaging Message
 */
export const createAdminMessagingMessage = async (conversationId: string,
    messagingMessageCreate: MessagingMessageCreate, options?: RequestInit): Promise<createAdminMessagingMessageResponse> => {

  return orvalClient<createAdminMessagingMessageResponse>(getCreateAdminMessagingMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingMessageCreate)
  }
);}




export const getCreateAdminMessagingMessageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext> => {

const mutationKey = ['createAdminMessagingMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminMessagingMessage>>, {conversationId: string;data: MessagingMessageCreate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  createAdminMessagingMessage(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminMessagingMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminMessagingMessage>>>
    export type CreateAdminMessagingMessageMutationBody = MessagingMessageCreate
    export type CreateAdminMessagingMessageMutationError = HTTPValidationError

    /**
 * @summary Create Admin Messaging Message
 */
export const useCreateAdminMessagingMessage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminMessagingMessage>>,
        TError,
        {conversationId: string;data: MessagingMessageCreate},
        TContext
      > => {
      return useMutation(getCreateAdminMessagingMessageMutationOptions(options), queryClient);
    }
    export type updateAdminMessagingOperationsResponse200 = {
  data: MessagingAdminConversation
  status: 200
}

export type updateAdminMessagingOperationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateAdminMessagingOperationsResponseSuccess = (updateAdminMessagingOperationsResponse200) & {
  headers: Headers;
};
export type updateAdminMessagingOperationsResponseError = (updateAdminMessagingOperationsResponse422) & {
  headers: Headers;
};

export type updateAdminMessagingOperationsResponse = (updateAdminMessagingOperationsResponseSuccess | updateAdminMessagingOperationsResponseError)

export const getUpdateAdminMessagingOperationsUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/operations`
}

/**
 * @summary Update Admin Messaging Operations
 */
export const updateAdminMessagingOperations = async (conversationId: string,
    messagingAdminOperationsRequest: MessagingAdminOperationsRequest, options?: RequestInit): Promise<updateAdminMessagingOperationsResponse> => {

  return orvalClient<updateAdminMessagingOperationsResponse>(getUpdateAdminMessagingOperationsUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingAdminOperationsRequest)
  }
);}




export const getUpdateAdminMessagingOperationsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, TError,{conversationId: string;data: MessagingAdminOperationsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, TError,{conversationId: string;data: MessagingAdminOperationsRequest}, TContext> => {

const mutationKey = ['updateAdminMessagingOperations'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, {conversationId: string;data: MessagingAdminOperationsRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateAdminMessagingOperations(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminMessagingOperationsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminMessagingOperations>>>
    export type UpdateAdminMessagingOperationsMutationBody = MessagingAdminOperationsRequest
    export type UpdateAdminMessagingOperationsMutationError = HTTPValidationError

    /**
 * @summary Update Admin Messaging Operations
 */
export const useUpdateAdminMessagingOperations = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminMessagingOperations>>, TError,{conversationId: string;data: MessagingAdminOperationsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminMessagingOperations>>,
        TError,
        {conversationId: string;data: MessagingAdminOperationsRequest},
        TContext
      > => {
      return useMutation(getUpdateAdminMessagingOperationsMutationOptions(options), queryClient);
    }
    export type markAdminMessagingConversationReadResponse200 = {
  data: MessagingReadReceipt
  status: 200
}

export type markAdminMessagingConversationReadResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type markAdminMessagingConversationReadResponseSuccess = (markAdminMessagingConversationReadResponse200) & {
  headers: Headers;
};
export type markAdminMessagingConversationReadResponseError = (markAdminMessagingConversationReadResponse422) & {
  headers: Headers;
};

export type markAdminMessagingConversationReadResponse = (markAdminMessagingConversationReadResponseSuccess | markAdminMessagingConversationReadResponseError)

export const getMarkAdminMessagingConversationReadUrl = (conversationId: string,) => {




  return `/api/v1/admin/messaging/conversations/${conversationId}/read`
}

/**
 * @summary Mark Admin Messaging Conversation Read
 */
export const markAdminMessagingConversationRead = async (conversationId: string,
    messagingReadRequest: MessagingReadRequest, options?: RequestInit): Promise<markAdminMessagingConversationReadResponse> => {

  return orvalClient<markAdminMessagingConversationReadResponse>(getMarkAdminMessagingConversationReadUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingReadRequest)
  }
);}




export const getMarkAdminMessagingConversationReadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext> => {

const mutationKey = ['markAdminMessagingConversationRead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, {conversationId: string;data: MessagingReadRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  markAdminMessagingConversationRead(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAdminMessagingConversationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>>
    export type MarkAdminMessagingConversationReadMutationBody = MessagingReadRequest
    export type MarkAdminMessagingConversationReadMutationError = HTTPValidationError

    /**
 * @summary Mark Admin Messaging Conversation Read
 */
export const useMarkAdminMessagingConversationRead = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAdminMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAdminMessagingConversationRead>>,
        TError,
        {conversationId: string;data: MessagingReadRequest},
        TContext
      > => {
      return useMutation(getMarkAdminMessagingConversationReadMutationOptions(options), queryClient);
    }
    export type getAdminMessagingUnreadSummaryResponse200 = {
  data: MessagingUnreadSummary
  status: 200
}

export type getAdminMessagingUnreadSummaryResponseSuccess = (getAdminMessagingUnreadSummaryResponse200) & {
  headers: Headers;
};
;

export type getAdminMessagingUnreadSummaryResponse = (getAdminMessagingUnreadSummaryResponseSuccess)

export const getGetAdminMessagingUnreadSummaryUrl = () => {




  return `/api/v1/admin/messaging/unread-summary`
}

/**
 * @summary Get Admin Messaging Unread Summary
 */
export const getAdminMessagingUnreadSummary = async ( options?: RequestInit): Promise<getAdminMessagingUnreadSummaryResponse> => {

  return orvalClient<getAdminMessagingUnreadSummaryResponse>(getGetAdminMessagingUnreadSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminMessagingUnreadSummaryQueryKey = () => {
    return [
    `/api/v1/admin/messaging/unread-summary`
    ] as const;
    }


export const getGetAdminMessagingUnreadSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminMessagingUnreadSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>> = ({ signal }) => getAdminMessagingUnreadSummary({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminMessagingUnreadSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>>
export type GetAdminMessagingUnreadSummaryQueryError = unknown


export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Admin Messaging Unread Summary
 */

export function useGetAdminMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminMessagingUnreadSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getMessagingCapabilitiesResponse200 = {
  data: MessagingCapabilities
  status: 200
}

export type getMessagingCapabilitiesResponse401 = {
  data: void
  status: 401
}

export type getMessagingCapabilitiesResponseDefault = {
  data: void
  status: Exclude<HTTPStatusCodes, 200 | 401>
}

export type getMessagingCapabilitiesResponseSuccess = (getMessagingCapabilitiesResponse200) & {
  headers: Headers;
};
export type getMessagingCapabilitiesResponseError = (getMessagingCapabilitiesResponse401 | getMessagingCapabilitiesResponseDefault) & {
  headers: Headers;
};

export type getMessagingCapabilitiesResponse = (getMessagingCapabilitiesResponseSuccess | getMessagingCapabilitiesResponseError)

export const getGetMessagingCapabilitiesUrl = () => {




  return `/api/v1/messaging/capabilities`
}

/**
 * Returns the effective Messaging rollout for the authenticated actor. Unknown, malformed, ineligible, or disabled states map to level=off. Admin operation flags are derived from exact Messaging capabilities; tenant can_send never implies admin can_reply.
 * @summary Get fail-closed Messaging rollout capabilities
 */
export const getMessagingCapabilities = async ( options?: RequestInit): Promise<getMessagingCapabilitiesResponse> => {

  return orvalClient<getMessagingCapabilitiesResponse>(getGetMessagingCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagingCapabilitiesQueryKey = () => {
    return [
    `/api/v1/messaging/capabilities`
    ] as const;
    }


export const getGetMessagingCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagingCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagingCapabilities>>> = ({ signal }) => getMessagingCapabilities({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagingCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagingCapabilities>>>
export type GetMessagingCapabilitiesQueryError = void


export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getMessagingCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getMessagingCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fail-closed Messaging rollout capabilities
 */

export function useGetMessagingCapabilities<TData = Awaited<ReturnType<typeof getMessagingCapabilities>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagingCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listMessagingConversationsResponse200 = {
  data: MessagingConversationPage
  status: 200
}

export type listMessagingConversationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listMessagingConversationsResponseSuccess = (listMessagingConversationsResponse200) & {
  headers: Headers;
};
export type listMessagingConversationsResponseError = (listMessagingConversationsResponse422) & {
  headers: Headers;
};

export type listMessagingConversationsResponse = (listMessagingConversationsResponseSuccess | listMessagingConversationsResponseError)

export const getListMessagingConversationsUrl = (params?: ListMessagingConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/messaging/conversations?${stringifiedParams}` : `/api/v1/messaging/conversations`
}

/**
 * @summary List conversations visible to the current app actor
 */
export const listMessagingConversations = async (params?: ListMessagingConversationsParams, options?: RequestInit): Promise<listMessagingConversationsResponse> => {

  return orvalClient<listMessagingConversationsResponse>(getListMessagingConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagingConversationsQueryKey = (params?: ListMessagingConversationsParams,) => {
    return [
    `/api/v1/messaging/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMessagingConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = HTTPValidationError>(params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagingConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessagingConversations>>> = ({ signal }) => listMessagingConversations(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMessagingConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listMessagingConversations>>>
export type ListMessagingConversationsQueryError = HTTPValidationError


export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = HTTPValidationError>(
 params: undefined |  ListMessagingConversationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = HTTPValidationError>(
 params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingConversations>>,
          TError,
          Awaited<ReturnType<typeof listMessagingConversations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = HTTPValidationError>(
 params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List conversations visible to the current app actor
 */

export function useListMessagingConversations<TData = Awaited<ReturnType<typeof listMessagingConversations>>, TError = HTTPValidationError>(
 params?: ListMessagingConversationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingConversations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMessagingConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createMessagingConversationResponse201 = {
  data: MessagingConversationRead
  status: 201
}

export type createMessagingConversationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createMessagingConversationResponseSuccess = (createMessagingConversationResponse201) & {
  headers: Headers;
};
export type createMessagingConversationResponseError = (createMessagingConversationResponse422) & {
  headers: Headers;
};

export type createMessagingConversationResponse = (createMessagingConversationResponseSuccess | createMessagingConversationResponseError)

export const getCreateMessagingConversationUrl = () => {




  return `/api/v1/messaging/conversations`
}

/**
 * @summary Start a conversation in the current actor's app scope
 */
export const createMessagingConversation = async (messagingConversationCreate: MessagingConversationCreate, options?: RequestInit): Promise<createMessagingConversationResponse> => {

  return orvalClient<createMessagingConversationResponse>(getCreateMessagingConversationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingConversationCreate)
  }
);}




export const getCreateMessagingConversationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingConversation>>, TError,{data: MessagingConversationCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMessagingConversation>>, TError,{data: MessagingConversationCreate}, TContext> => {

const mutationKey = ['createMessagingConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMessagingConversation>>, {data: MessagingConversationCreate}> = (props) => {
          const {data} = props ?? {};

          return  createMessagingConversation(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMessagingConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createMessagingConversation>>>
    export type CreateMessagingConversationMutationBody = MessagingConversationCreate
    export type CreateMessagingConversationMutationError = HTTPValidationError

    /**
 * @summary Start a conversation in the current actor's app scope
 */
export const useCreateMessagingConversation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingConversation>>, TError,{data: MessagingConversationCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMessagingConversation>>,
        TError,
        {data: MessagingConversationCreate},
        TContext
      > => {
      return useMutation(getCreateMessagingConversationMutationOptions(options), queryClient);
    }
    export type getMessagingConversationResponse200 = {
  data: MessagingConversationRead
  status: 200
}

export type getMessagingConversationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getMessagingConversationResponseSuccess = (getMessagingConversationResponse200) & {
  headers: Headers;
};
export type getMessagingConversationResponseError = (getMessagingConversationResponse422) & {
  headers: Headers;
};

export type getMessagingConversationResponse = (getMessagingConversationResponseSuccess | getMessagingConversationResponseError)

export const getGetMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}`
}

/**
 * @summary Get one own-scope conversation
 */
export const getMessagingConversation = async (conversationId: string, options?: RequestInit): Promise<getMessagingConversationResponse> => {

  return orvalClient<getMessagingConversationResponse>(getGetMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagingConversationQueryKey = (conversationId: string,) => {
    return [
    `/api/v1/messaging/conversations/${conversationId}`
    ] as const;
    }


export const getGetMessagingConversationQueryOptions = <TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = HTTPValidationError>(conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagingConversationQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagingConversation>>> = ({ signal }) => getMessagingConversation(conversationId, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagingConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagingConversation>>>
export type GetMessagingConversationQueryError = HTTPValidationError


export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingConversation>>,
          TError,
          Awaited<ReturnType<typeof getMessagingConversation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one own-scope conversation
 */

export function useGetMessagingConversation<TData = Awaited<ReturnType<typeof getMessagingConversation>>, TError = HTTPValidationError>(
 conversationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingConversation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagingConversationQueryOptions(conversationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type updateMessagingConversationResponse200 = {
  data: MessagingConversationRead
  status: 200
}

export type updateMessagingConversationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateMessagingConversationResponseSuccess = (updateMessagingConversationResponse200) & {
  headers: Headers;
};
export type updateMessagingConversationResponseError = (updateMessagingConversationResponse422) & {
  headers: Headers;
};

export type updateMessagingConversationResponse = (updateMessagingConversationResponseSuccess | updateMessagingConversationResponseError)

export const getUpdateMessagingConversationUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}`
}

/**
 * @summary Update one own-scope conversation status
 */
export const updateMessagingConversation = async (conversationId: string,
    messagingConversationUpdate: MessagingConversationUpdate, options?: RequestInit): Promise<updateMessagingConversationResponse> => {

  return orvalClient<updateMessagingConversationResponse>(getUpdateMessagingConversationUrl(conversationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingConversationUpdate)
  }
);}




export const getUpdateMessagingConversationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessagingConversation>>, TError,{conversationId: string;data: MessagingConversationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateMessagingConversation>>, TError,{conversationId: string;data: MessagingConversationUpdate}, TContext> => {

const mutationKey = ['updateMessagingConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMessagingConversation>>, {conversationId: string;data: MessagingConversationUpdate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  updateMessagingConversation(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMessagingConversationMutationResult = NonNullable<Awaited<ReturnType<typeof updateMessagingConversation>>>
    export type UpdateMessagingConversationMutationBody = MessagingConversationUpdate
    export type UpdateMessagingConversationMutationError = HTTPValidationError

    /**
 * @summary Update one own-scope conversation status
 */
export const useUpdateMessagingConversation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessagingConversation>>, TError,{conversationId: string;data: MessagingConversationUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMessagingConversation>>,
        TError,
        {conversationId: string;data: MessagingConversationUpdate},
        TContext
      > => {
      return useMutation(getUpdateMessagingConversationMutationOptions(options), queryClient);
    }
    export type listMessagingMessagesResponse200 = {
  data: MessagingMessagePage
  status: 200
}

export type listMessagingMessagesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listMessagingMessagesResponseSuccess = (listMessagingMessagesResponse200) & {
  headers: Headers;
};
export type listMessagingMessagesResponseError = (listMessagingMessagesResponse422) & {
  headers: Headers;
};

export type listMessagingMessagesResponse = (listMessagingMessagesResponseSuccess | listMessagingMessagesResponseError)

export const getListMessagingMessagesUrl = (conversationId: string,
    params?: ListMessagingMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/messaging/conversations/${conversationId}/messages?${stringifiedParams}` : `/api/v1/messaging/conversations/${conversationId}/messages`
}

/**
 * @summary List message history for one own-scope conversation
 */
export const listMessagingMessages = async (conversationId: string,
    params?: ListMessagingMessagesParams, options?: RequestInit): Promise<listMessagingMessagesResponse> => {

  return orvalClient<listMessagingMessagesResponse>(getListMessagingMessagesUrl(conversationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagingMessagesQueryKey = (conversationId: string,
    params?: ListMessagingMessagesParams,) => {
    return [
    `/api/v1/messaging/conversations/${conversationId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMessagingMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = HTTPValidationError>(conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagingMessagesQueryKey(conversationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessagingMessages>>> = ({ signal }) => listMessagingMessages(conversationId,params, { signal });





   return  { queryKey, queryFn, enabled: conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMessagingMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMessagingMessages>>>
export type ListMessagingMessagesQueryError = HTTPValidationError


export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params: undefined |  ListMessagingMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMessagingMessages>>,
          TError,
          Awaited<ReturnType<typeof listMessagingMessages>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List message history for one own-scope conversation
 */

export function useListMessagingMessages<TData = Awaited<ReturnType<typeof listMessagingMessages>>, TError = HTTPValidationError>(
 conversationId: string,
    params?: ListMessagingMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMessagingMessages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMessagingMessagesQueryOptions(conversationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createMessagingMessageResponse201 = {
  data: MessagingMessageRead
  status: 201
}

export type createMessagingMessageResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createMessagingMessageResponseSuccess = (createMessagingMessageResponse201) & {
  headers: Headers;
};
export type createMessagingMessageResponseError = (createMessagingMessageResponse422) & {
  headers: Headers;
};

export type createMessagingMessageResponse = (createMessagingMessageResponseSuccess | createMessagingMessageResponseError)

export const getCreateMessagingMessageUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}/messages`
}

/**
 * @summary Send an idempotent message in one own-scope conversation
 */
export const createMessagingMessage = async (conversationId: string,
    messagingMessageCreate: MessagingMessageCreate, options?: RequestInit): Promise<createMessagingMessageResponse> => {

  return orvalClient<createMessagingMessageResponse>(getCreateMessagingMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingMessageCreate)
  }
);}




export const getCreateMessagingMessageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext> => {

const mutationKey = ['createMessagingMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMessagingMessage>>, {conversationId: string;data: MessagingMessageCreate}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  createMessagingMessage(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMessagingMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createMessagingMessage>>>
    export type CreateMessagingMessageMutationBody = MessagingMessageCreate
    export type CreateMessagingMessageMutationError = HTTPValidationError

    /**
 * @summary Send an idempotent message in one own-scope conversation
 */
export const useCreateMessagingMessage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMessagingMessage>>, TError,{conversationId: string;data: MessagingMessageCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMessagingMessage>>,
        TError,
        {conversationId: string;data: MessagingMessageCreate},
        TContext
      > => {
      return useMutation(getCreateMessagingMessageMutationOptions(options), queryClient);
    }
    export type markMessagingConversationReadResponse200 = {
  data: MessagingReadReceipt
  status: 200
}

export type markMessagingConversationReadResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type markMessagingConversationReadResponseSuccess = (markMessagingConversationReadResponse200) & {
  headers: Headers;
};
export type markMessagingConversationReadResponseError = (markMessagingConversationReadResponse422) & {
  headers: Headers;
};

export type markMessagingConversationReadResponse = (markMessagingConversationReadResponseSuccess | markMessagingConversationReadResponseError)

export const getMarkMessagingConversationReadUrl = (conversationId: string,) => {




  return `/api/v1/messaging/conversations/${conversationId}/read`
}

/**
 * @summary Advance the actor's read position
 */
export const markMessagingConversationRead = async (conversationId: string,
    messagingReadRequest: MessagingReadRequest, options?: RequestInit): Promise<markMessagingConversationReadResponse> => {

  return orvalClient<markMessagingConversationReadResponse>(getMarkMessagingConversationReadUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(messagingReadRequest)
  }
);}




export const getMarkMessagingConversationReadMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext> => {

const mutationKey = ['markMessagingConversationRead'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markMessagingConversationRead>>, {conversationId: string;data: MessagingReadRequest}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  markMessagingConversationRead(conversationId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkMessagingConversationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markMessagingConversationRead>>>
    export type MarkMessagingConversationReadMutationBody = MessagingReadRequest
    export type MarkMessagingConversationReadMutationError = HTTPValidationError

    /**
 * @summary Advance the actor's read position
 */
export const useMarkMessagingConversationRead = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessagingConversationRead>>, TError,{conversationId: string;data: MessagingReadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markMessagingConversationRead>>,
        TError,
        {conversationId: string;data: MessagingReadRequest},
        TContext
      > => {
      return useMutation(getMarkMessagingConversationReadMutationOptions(options), queryClient);
    }
    export type getOrCreateMessagingSupportConversationResponse200 = {
  data: MessagingConversationRead
  status: 200
}

export type getOrCreateMessagingSupportConversationResponseSuccess = (getOrCreateMessagingSupportConversationResponse200) & {
  headers: Headers;
};
;

export type getOrCreateMessagingSupportConversationResponse = (getOrCreateMessagingSupportConversationResponseSuccess)

export const getGetOrCreateMessagingSupportConversationUrl = () => {




  return `/api/v1/messaging/support-conversation`
}

/**
 * @summary Get or create the current organization support conversation
 */
export const getOrCreateMessagingSupportConversation = async ( options?: RequestInit): Promise<getOrCreateMessagingSupportConversationResponse> => {

  return orvalClient<getOrCreateMessagingSupportConversationResponse>(getGetOrCreateMessagingSupportConversationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGetOrCreateMessagingSupportConversationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, TError,void, TContext> => {

const mutationKey = ['getOrCreateMessagingSupportConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, void> = () => {


          return  getOrCreateMessagingSupportConversation()
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetOrCreateMessagingSupportConversationMutationResult = NonNullable<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>>

    export type GetOrCreateMessagingSupportConversationMutationError = unknown

    /**
 * @summary Get or create the current organization support conversation
 */
export const useGetOrCreateMessagingSupportConversation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getOrCreateMessagingSupportConversation>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetOrCreateMessagingSupportConversationMutationOptions(options), queryClient);
    }
    export type getMessagingUnreadSummaryResponse200 = {
  data: MessagingUnreadSummary
  status: 200
}

export type getMessagingUnreadSummaryResponseSuccess = (getMessagingUnreadSummaryResponse200) & {
  headers: Headers;
};
;

export type getMessagingUnreadSummaryResponse = (getMessagingUnreadSummaryResponseSuccess)

export const getGetMessagingUnreadSummaryUrl = () => {




  return `/api/v1/messaging/unread-summary`
}

/**
 * @summary Get the current app membership's Messaging unread total
 */
export const getMessagingUnreadSummary = async ( options?: RequestInit): Promise<getMessagingUnreadSummaryResponse> => {

  return orvalClient<getMessagingUnreadSummaryResponse>(getGetMessagingUnreadSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMessagingUnreadSummaryQueryKey = () => {
    return [
    `/api/v1/messaging/unread-summary`
    ] as const;
    }


export const getGetMessagingUnreadSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMessagingUnreadSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessagingUnreadSummary>>> = ({ signal }) => getMessagingUnreadSummary({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMessagingUnreadSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMessagingUnreadSummary>>>
export type GetMessagingUnreadSummaryQueryError = unknown


export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>,
          TError,
          Awaited<ReturnType<typeof getMessagingUnreadSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the current app membership's Messaging unread total
 */

export function useGetMessagingUnreadSummary<TData = Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMessagingUnreadSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMessagingUnreadSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






